import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { t } from '../i18n';
import './DetailPreviewPagination.css';

function DetailPreviewPagination({ page, pageCount, onPageChange, ariaLabel }) {
  if (pageCount <= 1) return null;

  return (
    <nav className="detail-preview-pagination" aria-label={ariaLabel}>
      <button
        type="button"
        onClick={() => onPageChange(page - 1)}
        disabled={page <= 1}
      >
        <ChevronLeft size={17} aria-hidden="true" />
        {t('library.previous')}
      </button>
      <span aria-live="polite">
        {t('library.pageStatus', undefined, { page, pageCount })}
      </span>
      <button
        type="button"
        onClick={() => onPageChange(page + 1)}
        disabled={page >= pageCount}
      >
        {t('library.next')}
        <ChevronRight size={17} aria-hidden="true" />
      </button>
    </nav>
  );
}

export default DetailPreviewPagination;
